import MastersPageContent from '@/components/pages/masters-page';

export default function MastersPage() {
  return <MastersPageContent />;
}
